"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconBath = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M19.2,13.6 L19.2,14.4 C19.2,15.928 18.344,17.256 17.08,17.928 L17.6,20 L16,20 L15.6,18.4 C15.464,18.4 15.336,18.4 15.2,18.4 L8.8,18.4 C8.664,18.4 8.536,18.4 8.4,18.4 L8,20 L6.4,20 L6.92,17.928 C5.656,17.256 4.8,15.928 4.8,14.4 L4.8,13.6 L4,13.6 L4,12 L18.4,12 L18.4,6.4 C18.4,5.9581722 18.0418278,5.6 17.6,5.6 C17.2,5.6 16.896,5.872 16.8,6.232 C17.304,6.664 17.6,7.304 17.6,8 L12.8,8 C12.8,6.6745166 13.8745166,5.6 15.2,5.6 C15.248,5.6 15.288,5.6 15.336,5.6 C15.664,4.672 16.552,4 17.6,4 C18.9254834,4 20,5.0745166 20,6.4 L20,13.6 L19.2,13.6 L19.2,13.6"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconBath')(IconBath);